import {AllAccountsDocument} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';
import type {AllAccountsQuery, AccountFragment} from '@transactions/graphql';

export const setAccounts = (store: DataProxy, accounts: AccountFragment[]) => {
  const _data = store.readQuery<AllAccountsQuery>({
    query: AllAccountsDocument,
  });
  store.writeQuery({
    query: AllAccountsDocument,
    data: {
      allAccounts: accounts,
    },
  });
};
